// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueFire from 'vuefire'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.css'

const moment = require('moment')
require('moment/locale/es')

Vue.use(require('vue-moment'), {
  moment
})

Vue.use(VueMaterial)
Vue.use(VueFire)
Vue.use(router)
Vue.config.productionTip = false

Vue.material.registerTheme('default', {
  primary: 'deep-purple',
  accent: 'red',
  warn: 'red',
  background: 'white'
})

// Register a global custom directive called v-focus
Vue.directive('focus', function (el, binding) {
  el.focus()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
}).$mount('#app')

if (process.env.NODE_ENV === 'production') {
  var OneSignal = window.OneSignal || []
  OneSignal.push(['init', {
    appId: process.env.onesignal.appId,
    autoRegister: false,
    welcomeNotification: {
      'title': 'Feedback',
      'message': 'Gracias por suscribirse a las notificaciones!'
    }
  }])
}



// WEBPACK FOOTER //
// ./src/main.js